import dayjs from 'dayjs'

const simpleDate = date =>
  dayjs(String(date).substring(0, 10)).isValid()
    ? dayjs(String(date).substring(0, 10)).format('DD/MM/YYYY')
    : ''

export default simpleDate
